import React from 'react';
import menuBarIcon from '../../../../assets/image/menu-bar-icon.svg';
import { formatDateDDMMYYYY } from '../../../../utils/constant';
import Button from '../../../../component/ui/Button';

export default function ReportHeaderComponent({
	favIconButton = null,
	setIsCollapse,
	isCollapse,
	activeTab,
	fromDate,
	toDate,
	title,
	subtitle,
	buttons,
}) {
	return (
		<div
			className="d-flex py-4 px-2 justify-content-between align-items-center"
			style={{ borderBottom: '1px solid #EDEDF7' }}
		>
			<div className="d-flex gap-4 align-items-center">
				<div className="px-2">
					<img
						className="cursor-pointer"
						src={menuBarIcon}
						alt="Menu-bar"
						onClick={() => setIsCollapse(!isCollapse)}
					/>
				</div>
				<div>
					<div
						className="fs-4 fw-bold"
						style={{ color: '#0F1C35' }}
					>
						{title}
					</div>
					{subtitle && (
						<div className="d-flex gap-3 align-items-center">
							<div className="fs-3 fw-bold">{activeTab}</div>
							<div
								className="fs-4 fw-semibold"
								style={{ color: '#555B67' }}
							>
								{'(from '}
								<b style={{ color: '#000' }}>
									{fromDate ? formatDateDDMMYYYY(fromDate) : ''}
								</b> to <b style={{ color: '#000' }}>{toDate ? formatDateDDMMYYYY(toDate) : ''}</b>
								{')'}
							</div>
						</div>
					)}
				</div>
			</div>
			<div className="d-flex gap-3 align-items-center">
				{favIconButton && (
					<img
						className="cursor-pointer"
						src={favIconButton.fav_icon}
						onClick={favIconButton.handler}
						alt="fav-icon"
					/>
				)}
				{buttons?.map((button, index) => (
					<Button
						key={button?.id || index}
						type="button"
						button={button?.button}
						className={`${button?.className} mt-0 px-4`}
						onClick={button?.handler}
						loader={button?.loader}
						disabled={button?.disabled || false}
					/>
				))}
			</div>
		</div>
	);
}
